export default function Tab({
  value,
  currentTab,
  handleTabChange,
  inputStyle
}) {
  return (
    <button
      className={value === currentTab ? 'tab selected' : 'tab'}
      style={inputStyle}
      onClick={() => {
        handleTabChange(value);
      }}
    >
      {value}
    </button>
  );
}
